export default __webpack_public_path__ + "static/media/perksBenefitsIcon1.fb248337.png";